<template>
  <div :class="cn('relative flex h-64 items-center justify-center', props.class)">
    <div class="flex flex-col items-center justify-center gap-4">
      <UiCircularProgress :progress="progress">
        <video class="w-16" :src="getVideoUrl('bubble-loader.mp4')" autoplay muted loop />
      </UiCircularProgress>
      <slot name="text" />
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  class?: ClassValue
  progress: number
}>()

const progress = computed(() => props.progress ?? 0)
</script>
